@if (isCategorySelected) {
    <div class="section-header-container category-section-header-container">
        <app-category-market-section-header [category$]="category$"></app-category-market-section-header>
    </div>
} @else {
    <div class="section-header-container main-section-header-container">
        <app-main-market-section-header></app-main-market-section-header>
    </div>
}